import { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Button, Input, Link } from '../../../..'
import { mediaForm as mediaFormProps } from '../../../../../types'
import { DEFAULT_IMAGE_LENGTH } from '../../../../../reducers/content/initialState'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    CloseButton,
    FlexBox,
    ContainerBox,
    MediaLabel,
    MediaInputBox,
    MediaInputBoxLabel,
    InputStyle,
    RemoveIcon,
    MediaButtons,
    MediaButtonStyle,
    CalendarIcon,
    Schedule,
} from './Media.style'
import { colors } from '../../../../../constants'

class MediaForm extends PureComponent {
    static propTypes = {
        errors: PropTypes.shape({
            name: PropTypes.string,
            file: PropTypes.string,
            date_start: PropTypes.string,
            date_end: PropTypes.string,
            length: PropTypes.string,
        }),
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool,
        values: PropTypes.shape(mediaFormProps),
        onChangeForm: PropTypes.shape({
            name: PropTypes.func,
            file: PropTypes.func,
            date_start: PropTypes.func,
            date_end: PropTypes.func,
            metadata: PropTypes.func,
        }),
        onClickCancel: PropTypes.func,
        onClickSubmit: PropTypes.func,
        onClickNullStartDate: PropTypes.func.isRequired,
        onClickNullEndDate: PropTypes.func.isRequired,
        onClickRemoveStartDate: PropTypes.func.isRequired,
        onClickRemoveEndDate: PropTypes.func.isRequired,
        progress: PropTypes.number.isRequired,
        t: PropTypes.func.isRequired,
        onTextChangePlaylists: PropTypes.func,
        optionsPlaylists: PropTypes.func,
        selectedPlaylist: PropTypes.any,
        setPlaylistValue: PropTypes.func,
        fileName: PropTypes.string,
    }

    static defaultProps = {
        errors: {
            name: null,
            file: null,
            date_start: null,
            date_end: null,
        },
        isOpen: false,
        isWorking: false,
        values: {},
        onChangeForm: {
            name: () => null,
            media: () => null,
            date_start: () => null,
            date_end: () => null,
            length: () => null,
        },
        onClickCancel: () => null,
        onClickSubmit: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            displaySchedular: false,
        }
    }

    /**
     * If a file has been selected to be upload
     */
    get hasFile() {
        const { values } = this.props
        const { file } = values || {}
        return !!file.length && file[0] instanceof File
    }

    /**
     * If the selected media is an image
     */
    get isFileImage() {
        const { type = '' } = this.file || {}
        return type.includes('image')
    }

    /**
     * If the selected media is a video
     */
    get isFileVideo() {
        const { type = '' } = this.file || {}
        return type.includes('video')
    }

    /**
     * Get file object for selected media to upload
     */
    get file() {
        const { values } = this.props
        const { file } = values || {}
        return file[0]
    }

    /**
     * Progress in 100 per cent
     */
    get progress() {
        const { progress } = this.props
        return Math.round(progress * 100)
    }

    /**
     * Video length needs to be calculated after rendering the video in html,
     * so this function is triggered when the <video> tag finishes loading the metadata
     */
    onVideoMetadataChange = (e) => {
        if (!this.hasFile || !this.isFileVideo) {
            return null
        }

        // Get metadata
        const {
            target: { videoHeight, videoWidth, duration },
        } = e

        const { onChangeForm } = this.props
        const { metadata: onChangeMetadata } = onChangeForm
        const videoLength = duration * 1000 // Set to ms

        const metadata = { videoHeight, videoLength, videoWidth }

        // If onChangeMetadata function exists
        if (onChangeMetadata instanceof Function) {
            onChangeMetadata(metadata)
        }
    }

    /**
     * If the file selected to upload is an image, we should trigger the onChangeLength event
     * with the default length
     */
    innerOnChangeFile = (...args) => {
        const { onChangeForm } = this.props
        const { length: onChangeLength, file: onChangeFile } = onChangeForm

        if (onChangeFile instanceof Function) {
            onChangeFile(...args)
        }

        // If file has been set, and it's an image, send the default image length
        if (this.hasFile && this.isFileImage && onChangeLength instanceof Function) {
            onChangeLength({
                target: { name: 'length', value: DEFAULT_IMAGE_LENGTH },
            })
        }
    }

    /**
     * Render Start Date label
     */
    renderStartDateLabel() {
        const { onClickRemoveStartDate, t } = this.props

        return (
            <Fragment>
                {t('date-start')}
                &nbsp;
                <Link onClick={onClickRemoveStartDate}>&times;</Link>
            </Fragment>
        )
    }

    /**
     * Render End label
     */
    renderEndDateLabel() {
        const { onClickRemoveEndDate, t } = this.props

        return (
            <Fragment>
                {t('date-end')}
                &nbsp;
                <Link onClick={onClickRemoveEndDate}>&times;</Link>
            </Fragment>
        )
    }

    toggleCalendar = () => {
        this.setState({ displaySchedular: !this.state.displaySchedular })
    }

    /**
     * Render
     */
    render() {
        const {
            errors,
            onChangeForm,
            values,
            t,
            onClickRemoveMedia,
            index,
            onTextChangePlaylists,
            optionsPlaylists,
            selectedPlaylist,
            setPlaylistValue,
            onClickRemoveStartDate,
            isWorking,
            fileName,
            onClickNullStartDate,
            onClickNullEndDate,
        } = this.props
        const { name: errorName, date_start: errorDateStart, date_end: errorDateEnd, length: errorLength } = errors
        const { name, date_start, date_end, length } = values
        const { name: onChangeName, date_start: onChangeDateStart, date_end: onChangeDateEnd, length: onChangeLength } = onChangeForm
        const { displaySchedular } = this.state
        return (
            <ContainerBox>
                <FlexBox>
                    <MediaLabel>
                        {index + 1}.{fileName}
                    </MediaLabel>
                    <MediaInputBox>
                        <MediaInputBoxLabel>{t('Filename')}:</MediaInputBoxLabel>
                        <Input id="name" name="name" type="text" error={!!errorName} onChange={onChangeName} size="md" value={name} style={InputStyle} />
                    </MediaInputBox>
                    <MediaInputBox>
                        <MediaInputBoxLabel>{t('Playlist')}:</MediaInputBoxLabel>
                        <Input
                            size="md"
                            style={InputStyle}
                            type="suggestions"
                            onChange={(val) => setPlaylistValue(val)}
                            onTextChange={onTextChangePlaylists}
                            options={optionsPlaylists()}
                            placeholder="Select a Playlist"
                            notRelative
                            value={selectedPlaylist.value}
                        />
                    </MediaInputBox>
                    <MediaButtons>
                        <Button
                            style={MediaButtonStyle}
                            theme="forestGreen"
                            radius="5"
                            onClick={() => {
                                this.toggleCalendar()
                                onClickNullStartDate()
                                onClickNullEndDate()
                            }}
                            disabled={isWorking}
                        >
                            <CalendarIcon />
                        </Button>
                        <Button style={MediaButtonStyle} theme="danger" radius="5" onClick={onClickRemoveMedia} disabled={isWorking}>
                            <RemoveIcon />
                        </Button>
                    </MediaButtons>
                </FlexBox>
                {
                    // If file uploaded is an image
                    this.isFileImage && (
                        <FlexBox style={{ paddingBottom: '15px', justifyContent: `flex-end`, paddingRight: `75px` }}>
                            <MediaInputBox style={{ width: '42%' }}>
                                <MediaInputBoxLabel style={{ width: '51%' }}>{t('Length(seconds)')}:</MediaInputBoxLabel>
                                <Input
                                    id="length"
                                    name="length"
                                    type="number"
                                    error={!!errorLength}
                                    min={0}
                                    onChange={onChangeLength}
                                    size="md"
                                    value={length}
                                    style={InputStyle}
                                />
                            </MediaInputBox>
                        </FlexBox>
                    )
                }
                {
                    // if file uploaded is a video
                    displaySchedular && (
                        <FlexBox style={{ borderBottom: `1px solid ${colors.greylight}`, paddingBottom: '15px' }}>
                            <Schedule>{t('Scheduled')}</Schedule>
                            <MediaInputBox style={{ width: '42%' }}>
                                <MediaInputBoxLabel style={{ width: '51%' }}>{t('Starting date')}:</MediaInputBoxLabel>
                                <Input
                                    id="date_start"
                                    name="date_start"
                                    type="date"
                                    error={!!errorDateStart}
                                    onChange={onChangeDateStart}
                                    value={date_start}
                                    withTime
                                    style={InputStyle}
                                />
                                <CloseButton
                                    onClick={() => {
                                        onClickRemoveStartDate()
                                        this.toggleCalendar()
                                    }}
                                >
                                    <FontAwesomeIcon style={{ fontSize: '1.3rem' }} color={colors.blue} icon="times" />
                                </CloseButton>
                            </MediaInputBox>
                            <MediaInputBox style={{ width: '42%' }}>
                                <MediaInputBoxLabel style={{ width: '51%' }}>{t('Ending date')}:</MediaInputBoxLabel>
                                <Input
                                    id="date_end"
                                    name="date_end"
                                    type="date"
                                    error={!!errorDateEnd}
                                    onChange={onChangeDateEnd}
                                    value={date_end}
                                    withTime
                                    style={InputStyle}
                                />
                                <CloseButton
                                    onClick={() => {
                                        onClickRemoveStartDate()
                                        this.toggleCalendar()
                                    }}
                                >
                                    <FontAwesomeIcon style={{ fontSize: '1.3rem' }} color={colors.blue} icon="times" />
                                </CloseButton>
                            </MediaInputBox>
                        </FlexBox>
                    )
                }
            </ContainerBox>
        )
    }
}

export default MediaForm
